<template>
    <span>
        <a v-if="isExternal" v-bind="$attrs" :href="to">
            <slot></slot>
        </a>
        <router-link v-else v-bind="$attrs" :to="to" tag="a">
            <slot></slot>
        </router-link>
    </span>
</template>

<script>
export default {
    name: 'OtisakLink',

    props: {
        to: {
            type: String,
            required: true
        }
    },

    computed: {
        isExternal() {
            return this.to.startsWith('http');
        }
    }
}
</script>

<style lang="scss" scoped>
a, a:visited {
    display: inline;
    text-decoration: none;
    position: relative;
    color: #1969d2;

    &:after {
        content: '';
        position: absolute;
        height: 1px;
        bottom: -2px;
        left: 0;
        width: 0;
        background: #1969d2;
        transition: 0.2s;
    }

    &:hover {
        opacity: 0.94;
        &::after {
            width: 100%;
        }
    }
}
</style>
